import React from 'react';

class ResultPaymentOption extends React.Component {

    constructor(props) {
        super(props);
        this.state = props.paymentOption;
    }

    formatPaymentOptionCurrency = (amt) => {
        var fmtr = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        return fmtr.format(amt).replace(/\D00$/, '');
    }

    render() {

        return (
            <div className={`mam-more-options-product`}>
                <div className={`mam-payment-option-value-product`}>{this.state.Product}</div>
                <div className={`mam-payment-option-value-rate`}>{this.state.Rate}%</div>
                <div className={`mam-payment-option-value-apr`}>{this.state.APR}%</div>
                <div className={`mam-payment-option-value-payment`}>{this.formatPaymentOptionCurrency(this.state.Payment)}</div>
            </div>
        );
    }
}

export default ResultPaymentOption;